import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionLink,
  CvSectionLinkItem,
  CvSectionLinkItemResponse,
  CvSectionLinkResponse,
  UpdateCvSectionLinkItemRequest,
} from '@/../gen';

export const namespace = 'cvSectionLinkItemEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionLink = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_LINK');
export const SetCvSectionLink = actionCreator<CvSectionLinkResponse>(
  'SET_CV_SECTION_LINK'
);
export const GetCvSectionLinkItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_link_id: number;
    id: number;
  };
}>('GET_CV_SECTION_LINK_ITEM');
export const SetCvSectionLinkItem = actionCreator<CvSectionLinkItemResponse>(
  'SET_CV_SECTION_LINK_ITEM'
);
export const UpdateCvSectionLinkItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_link_id: number;
    id: number;
  };
  body: UpdateCvSectionLinkItemRequest;
}>('UPDATE_CV_SECTION_LINK_ITEM');
export const DeleteCvSectionLinkItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_link_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_LINK_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionLink: CvSectionLink;
  cvSectionLinkItem: CvSectionLinkItem;
}

const initialState = (): State => {
  return { cvSectionLink: null, cvSectionLinkItem: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionLink, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionLink(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLink(data.data));
    }),
    action(GetCvSectionLinkItem, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionLinkItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_link_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLinkItem(data.data));
    }),
    action(UpdateCvSectionLinkItem, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionLinkItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_link_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionLinkItem(data.data));
    }),
    action(DeleteCvSectionLinkItem, async function(context, action) {
      await this.proffApi.deleteCvSectionLinkItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_link_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionLinkItem(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionLink, (state, action) => {
      state.cvSectionLink = action.payload?.attributes;
    }),
    mutation(SetCvSectionLinkItem, (state, action) => {
      state.cvSectionLinkItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionLink: state => state.cvSectionLink,
    cvSectionLinkItem: state => state.cvSectionLinkItem,
  },
};
